export default [

  {
    label: 'Snow Depth',
    name: 'snow_depth',
    order: 1,
  },

  {
    label: 'Precip Accumulated',
    name: 'precip_accum',
    order: 2,
  },

  {
    label: 'Air Temperature',
    name: 'air_temp',
    order: 3,
  },

  {
    label: 'Wind Direction',
    name: 'wind_direction',
    order: 4,
  },

  {
    label: 'Wind Speed',
    name: 'wind_speed',
    order: 5,
  },

  {
    label: 'Wind Gust',
    name: 'wind_gust',
    order: 6,
  },

  {
    label: 'Peak Wind Speed',
    name: 'peak_wind_speed',
    order: 7,
  },

];



// WEBPACK FOOTER //
// ./src/models/favorite-variables.js